function Navbar({ cartCount }) {
  return (
    <nav className="navbar">
      <h2
        className="logo"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        Foodie
      </h2>
      <div className="links">
        <a href="#top">Home</a>
        <a href="#menu">Menu</a>
        <a href="#contact">Contact</a>
        <a href="#cart">Cart🛒 {cartCount}</a>
      </div>
    </nav>
  );
}

export default Navbar;